import { PureComponent } from "react";
import { universalSearchOnFocus } from "../../actions/universalSearchActions";
import { setStateCompareStatusAction, setUserCompareStatusAction } from "../../actions/userData/userEngagementActions";
import "./QueryBar.scss";
import { setStateCompareStatus, setUserCompareStatue } from "./QueryBarUtils";
import type { UIRouterReact } from "@uirouter/react/lib/core";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export abstract class BaseQueryBar<P = {}, S = {}> extends PureComponent<P & { router: UIRouterReact }, S> {
    protected ref;
    protected services;
    private navigationSuccessHandler;
    private setStateInProgress;

    constructor(props) {
        super(props);

        this.services = {
            swNavigator: proNavigator,
        };
    }

    public componentDidMount() {
        this.navigationSuccessHandler = this.props.router.transitionService.onSuccess({}, (transition) => {
            this.setStateInProgress = true;
            this.setState(this.getState(), () => {
                this.setStateInProgress = false;
            });
        });
    }

    public componentWillUnmount() {
        if (typeof this.navigationSuccessHandler === "function") {
            this.navigationSuccessHandler();
        }
    }

    public componentDidUpdate(prevProps, prevState) {
        // console.log('update');window.dispatchEvent(new Event('resize'));
    }

    protected abstract getState();
}

export const mapStateToProps = ({
    userData: {
        userEngagement: { userDidCompare, states },
    },
    routing: { pageChanged, chosenItems = [] },
    QueryBarReducer: { isCompareButtonOpen, tooltip },
}) => {
    return {
        userDidCompare,
        statesDidCompare: states,
        pageChanged,
        chosenItems,
        isCompareButtonOpen,
        tooltip,
    };
};

export const mapDispatchToProps = (dispatch, props) => {
    return {
        onUserDidCompare: () => {
            if (!props.userDidCompare) {
                setUserCompareStatue();
                dispatch(setUserCompareStatusAction(true));
            }
        },
        onStateCompare: (stateId) => {
            setStateCompareStatus(stateId);
            dispatch(setStateCompareStatusAction(stateId));
        },
        universalSearchOnFocus: (searchText) => {
            dispatch(universalSearchOnFocus(searchText));
        },
        toggleCompareButton: (action) => {
            dispatch(action);
        },
    };
};
